import { api, badge, flashMessage, formatter, modal, translate } from './util';
import { medicalDeviceHelper } from './medical-device';
import { searchFormHelper } from './search-form';

/**
 * Shared features of medical device groups.
 */
var medicalDeviceGroupHelper = (function ($) {
	/**
	 * Redirect to the medical device group details.
	 *
	 * @param {object} event Event data.
	 * @param {{
	 *     medicalDeviceGroup: {
	 *         id: string,
	 *         name: string,
	 *         medicalDeviceCount: int
	 *     }
	 * }} response Data returned from the server.
	 */
	var redirectToMedicalDeviceGroupDetail = function (event, response) {
		location.href = '/medical-device-groups/' + response.medicalDeviceGroup.id;
	};

	/**
	 * Handle successful save of notification settings.
	 *
	 * @param {object} event Event data.
	 * @param {string} groupId Id of updated medical device group.
	 * @param {{
	 *     notificationSettings: {
	 *         zpscauDiffFrequency: string,
	 *         zumSzpDiffFrequency: string,
	 *         zumVzpDiffFrequency: string,
	 *         procedureFrequency: string,
	 *         distributionFrequency: string
	 *     }
	 * }} response Data returned from the server.
	 */
	var notificationSettingsSaved = function (event, groupId, response) {
		updateNotificationSettings(
			$('.medical-device-group[data-group-id=' + groupId + ']'),
			response.notificationSettings.zpscauDiffFrequency,
			response.notificationSettings.zumSzpDiffFrequency,
			response.notificationSettings.zumVzpDiffFrequency,
			response.notificationSettings.procedureFrequency,
			response.notificationSettings.distributionFrequency
		);
		flashMessage.show('success', $('.notification-settings-modal').data('success-message'));
	};

	/**
	 * Update notification settings.
	 *
	 * @param {object} medicalDeviceGroupContainer Container of the medical device group.
	 * @param {string} zpscauDiffFrequency Frequency of ZPSCAU diff (monthly / disabled).
	 * @param {string} zumSzpDiffFrequency Frequency of ZUM SZP diff (monthly / disabled).
	 * @param {string} zumVzpDiffFrequency Frequency of ZUM VZP diff (monthly / disabled).
	 * @param {string} procedureFrequency Frequency of new procedure notifications (immediate / disabled).
	 * @param {string} distributionFrequency Frequency of distribution notifications (quarterly / disabled).
	 */
	var updateNotificationSettings = function (
		medicalDeviceGroupContainer,
		zpscauDiffFrequency,
		zumSzpDiffFrequency,
		zumVzpDiffFrequency,
		procedureFrequency,
		distributionFrequency
	) {
		medicalDeviceGroupContainer.data('zpscau-diff-frequency', zpscauDiffFrequency);
		medicalDeviceGroupContainer.data('zum-szp-diff-frequency', zumSzpDiffFrequency);
		medicalDeviceGroupContainer.data('zum-vzp-diff-frequency', zumVzpDiffFrequency);
		medicalDeviceGroupContainer.data('procedure-frequency', procedureFrequency);
		medicalDeviceGroupContainer.data('distribution-frequency', distributionFrequency);
		medicalDeviceGroupContainer
			.find('.btn-notification')
			.toggleClass(
				'btn-notification-act',
				zpscauDiffFrequency !== 'disabled' ||
					zumSzpDiffFrequency !== 'disabled' ||
					zumVzpDiffFrequency !== 'disabled' ||
					procedureFrequency !== 'disabled' ||
					distributionFrequency !== 'disabled'
			);
	};

	var createSaveFiltersApiRequest = function (groupId) {
		var values = searchFormHelper.getSearchFormValues();
		var operator = searchFormHelper.getOperatorValue();
		var filters = [];

		for (var i = 0; i < values.length; i++) {
			filters.push({
				type: getFilterType(values[i].name),
				value: values[i].value,
			});
		}

		if (filters.length === 0) {
			filters.push({
				type: 'all',
				value: '',
			});
		}

		return api.put(
			'/users/' +
				encodeURIComponent(api.getUserId()) +
				'/medical-device-groups/' +
				encodeURIComponent(groupId) +
				'/filters',
			{
				medicalDeviceGroupFilters: filters,
				operator: operator,
			}
		);
	};

	/**
	 * Handle successful rename of medical device group.
	 *
	 * @param {object} event Event data.
	 * @param {{
	 *     medicalDeviceGroup: {
	 *         id: string,
	 *         name: string,
	 *         devicesCount: int
	 *     }
	 * }} response Data returned from the server.
	 */
	var updateMedicalDeviceGroupName = function (event, response) {
		$('.medical-device-group[data-group-id=' + response.medicalDeviceGroup.id + '] .medical-device-group-name')
			.attr('title', response.medicalDeviceGroup.name)
			.text(response.medicalDeviceGroup.name);

		modal.hide();
	};

	var getFilterType = function (name) {
		var type = name
			.replace('filter-', '')
			.split('-')
			.map(function (part) {
				return part.charAt(0).toUpperCase() + part.substring(1);
			})
			.join('');

		return type.charAt(0).toLowerCase() + type.substring(1);
	};

	return {
		redirectToMedicalDeviceGroupDetail: redirectToMedicalDeviceGroupDetail,
		notificationSettingsSaved: notificationSettingsSaved,
		updateNotificationSettings: updateNotificationSettings,
		createSaveFiltersApiRequest: createSaveFiltersApiRequest,
		updateMedicalDeviceGroupName: updateMedicalDeviceGroupName,
	};
})(jQuery);

/**
 * Features of medical device group list.
 */
var medicalDeviceGroupList = (function ($) {
	var root;

	var init = function () {
		root = $('.medical-device-group-list');

		if (root.length === 0) {
			return;
		}

		root.find('.search-form-container').searchForm();
		root.find('.btn-create-medical-device-group').createMedicalDeviceGroupModal('.create-medical-device-group-modal');
		root.find('.content-list .btn-load-more').loadMore(getMedicalDeviceGroupsApiUrl(), createContainers);

		attachMedicalDeviceGroupContainerHandlers(root.find('.medical-device-groups .medical-device-group'));

		$(document).on('medicalDeviceGroup.created', medicalDeviceGroupHelper.redirectToMedicalDeviceGroupDetail);
		$(document).on('medicalDeviceGroup.notificationSettingsSaved', medicalDeviceGroupHelper.notificationSettingsSaved);
		$(document).on('medicalDeviceGroup.renamed', medicalDeviceGroupHelper.updateMedicalDeviceGroupName);
		$(document).on('medicalDeviceGroup.removed', removeMedicalDeviceGroupContainer);
	};

	var attachMedicalDeviceGroupContainerHandlers = function (medicalDeviceGroupContainers) {
		medicalDeviceGroupContainers.find('.btn-options').popover('.popover');
		medicalDeviceGroupContainers
			.find('.btn-notification')
			.medicalDeviceNotificationSettingsModal('.notification-settings-modal');
		medicalDeviceGroupContainers
			.find('.popover .btn-rename')
			.renameMedicalDeviceGroupModal('.rename-medical-device-group-modal');
		medicalDeviceGroupContainers
			.find('.popover .btn-remove')
			.removeMedicalDeviceGroupModal('.remove-medical-device-group-modal');
	};

	var getMedicalDeviceGroupsApiUrl = function () {
		return '/users/' + encodeURIComponent(api.getUserId()) + '/medical-device-groups';
	};

	/**
	 * Load next medical device group by AJAX.
	 */
	var removeMedicalDeviceGroupContainer = function (event, groupId) {
		root.find('.medical-device-group[data-group-id=' + groupId + ']').remove();
		modal.hide();
		flashMessage.show('success', root.find('.remove-medical-device-group-modal').data('success-message'));

		if (!root.find('.content-list .btn-load-more').is(':visible')) {
			return;
		}

		api
			.get(getMedicalDeviceGroupsApiUrl() + '?page=' + (root.find('.medical-device-group').length + 1) + '&perPage=1')
			.done(createContainers);
	};

	/**
	 * Create medical device group containers from data.
	 *
	 * @param {{
	 *     items: {
	 *         id: string,
	 *         name: string,
	 *         medicalDevicesCount: int
	 *     }[],
	 *     pagination:{
	 *         total:int,
	 *         perPage:int,
	 *         currentPage:int,
	 *         totalPages:int
	 *     }
	 * }} response Data returned from the server.
	 */
	var createContainers = function (response) {
		root.find('.content-list .btn-load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);

		for (var i = 0; i < response.items.length; i++) {
			createContainer(response.items[i]);
		}
	};

	/**
	 * Create medical device group container.
	 *
	 * @param {{
	 *     id: string,
	 *     name: string,
	 *     medicalDevicesCount: int,
	 * }} medicalDeviceGroup Definition of the medical device group.
	 */
	var createContainer = function (medicalDeviceGroup) {
		var medicalDeviceGroupsContainer = root.find('.medical-device-groups');
		var medicalDeviceGroupContainer = medicalDeviceGroupsContainer.find('.medical-device-group:first').clone();
		var medicalDevicesCount = medicalDeviceGroup.medicalDevicesCount;
		var medicalDevicesCountText = translate.selectForm(medicalDeviceGroupsContainer.data(), medicalDevicesCount);

		medicalDeviceGroupContainer.attr('data-group-id', medicalDeviceGroup.id);
		medicalDeviceGroupContainer
			.find('.medical-device-group-name')
			.attr('href', '/medical-device-groups/' + medicalDeviceGroup.id)
			.attr('title', medicalDeviceGroup.name)
			.text(medicalDeviceGroup.name);

		var additionalContainer = medicalDeviceGroupContainer.find('p');
		additionalContainer.find('span').text(formatter.formatNumber(medicalDevicesCount) + ' ' + medicalDevicesCountText);
		additionalContainer.find('a').attr('href', '/medical-device-groups/' + medicalDeviceGroup.id + '/distribution');

		medicalDeviceGroupHelper.updateNotificationSettings(
			medicalDeviceGroupContainer,
			medicalDeviceGroup.notification.settings.zpscauDiffFrequency,
			medicalDeviceGroup.notification.settings.zumSzpDiffFrequency,
			medicalDeviceGroup.notification.settings.zumVzpDiffFrequency,
			medicalDeviceGroup.notification.settings.procedureFrequency,
			medicalDeviceGroup.notification.settings.distributionFrequency
		);

		attachMedicalDeviceGroupContainerHandlers(medicalDeviceGroupContainer);

		medicalDeviceGroupsContainer.append(medicalDeviceGroupContainer);
	};

	return {
		init: init,
	};
})(jQuery);

/**
 * Features of medical device group detail.
 */
var medicalDeviceGroupDetail = (function ($) {
	var root;

	var init = function () {
		root = $('.medical-device-group-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.btn-options').popover('.popover');
		root.find('.btn-notification').medicalDeviceNotificationSettingsModal('.notification-settings-modal');
		root.find('.popover .btn-remove').removeMedicalDeviceGroupModal('.remove-medical-device-group-modal');
		root.find('.popover .btn-rename').renameMedicalDeviceGroupModal('.rename-medical-device-group-modal');
		root.find('.btn-save').apiButton(createSaveFiltersApiRequestWithSpinner);
		root.find('.btn-cancel').click(cancelChangeFilters);
		root.find('.btn-edit').click(openSearchForm);
		root.find('.medical-device-table .table tbody tr').clickableRow('btn-detail');
		root
			.find('.medical-device-table .btn-load-more')
			.loadMore(getMedicalDeviceGroupUrl() + '/medical-devices', medicalDeviceHelper.appendMedicalDeviceTableRows);

		$(document).on('medicalDeviceGroup.notificationSettingsSaved', medicalDeviceGroupHelper.notificationSettingsSaved);
		$(document).on('medicalDeviceGroup.renamed', medicalDeviceGroupHelper.updateMedicalDeviceGroupName);
		$(document).on('medicalDeviceGroup.removed', redirectToMedicalDeviceGroupList);

		var datagrid = {
			page: 1,
			order: 'codeAsc',
			defaultOrder: 'codeAsc',
		};

		root
			.find('a[data-medical-device-sort]')
			.sortButton(
				medicalDeviceHelper.getMedicalDeviceApiUrl(),
				medicalDeviceHelper.sortMedicalDeviceTableRows,
				datagrid
			);
	};

	var getMedicalDeviceGroupId = function () {
		return root.find('.medical-device-group').data('group-id');
	};

	var getMedicalDeviceGroupUrl = function () {
		return (
			'/users/' +
			encodeURIComponent(api.getUserId()) +
			'/medical-device-groups/' +
			encodeURIComponent(getMedicalDeviceGroupId())
		);
	};

	var redirectToMedicalDeviceGroupList = function () {
		location.href = '/medical-device-groups';
	};

	var openSearchForm = function () {
		root.find('.medical-device-group-edit-close').hide();
		root.find('.medical-device-group-edit-open').show();
		cloneSearchFormContainer();
	};

	var cloneSearchFormContainer = function () {
		// Clone the search form, so it is possible to cancel all changes with cancel button.
		// There is a problem with copying state of selects, so 'selected' attributed needs to be set.
		var originalSearchFormContainer = root.find('.search-form-container');
		originalSearchFormContainer.find('select').each(setOptionsSelectedAttribute);

		var searchFormContainer = originalSearchFormContainer.clone(true);
		root.find('.medical-device-group-search-form').prepend(searchFormContainer);

		// Initialize the search form.
		searchFormContainer.show();
		searchFormContainer.searchForm();
	};

	var setOptionsSelectedAttribute = function () {
		$(this)
			.find('option')
			.each(function () {
				$(this).attr('selected', $(this).is(':selected'));
			});
	};

	var cancelChangeFilters = function () {
		// Remove the search form which has been cloned in the openSearchForm function and this way
		// effectively discard all changes in medical device group filters which should not be saved.
		var containers = root.find('.medical-device-group-search-form .search-form-container');

		if (containers.length > 1) {
			containers.first().remove();
		}

		// Close the search form.
		closeSearchForm();
	};

	var closeSearchForm = function () {
		hideSearchFormContainer();
		root.find('.medical-device-group-edit-open').hide();
		root.find('.medical-device-group-edit-close').show();
	};

	var hideSearchFormContainer = function () {
		var searchFormContainer = root.find('.medical-device-group-edit-open .search-form-container');
		searchFormContainer.searchForm('destroy');
		searchFormContainer.hide();
		badge.hide(root.find('.buttons .badge'));
	};

	var loadMedicalDevices = function (url) {
		var medicalDeviceTableContainer = root.find('.medical-device-table');
		var medicalDeviceTable = medicalDeviceTableContainer.find('.table');
		var loadingContainer = medicalDeviceTableContainer.find('.loading-container');

		medicalDeviceTable.hide();
		medicalDeviceTableContainer.find('.load-more').hide();
		medicalDeviceTableContainer.find('.no-results-container').hide();
		loadingContainer.show();

		api.get(url).done(function (response) {
			loadingContainer.hide();

			// Update the medical device table.
			medicalDeviceTable.find('tbody tr').remove();
			medicalDeviceHelper.appendMedicalDeviceTableRows(response);
			medicalDeviceTable.find('tbody tr').clickableRow('btn-detail');

			// Update medical devices count.
			root.find('.medical-device-group-medical-devices-count').text(formatter.formatNumber(response.pagination.total));

			// Initialize the load more button.
			var loadMoreButton = medicalDeviceTableContainer.find('.btn-load-more');
			loadMoreButton.unbind('click');
			loadMoreButton.loadMore(url, medicalDeviceHelper.appendMedicalDeviceTableRows);
		});
	};

	var createSaveFiltersApiRequestWithSpinner = function () {
		root.find('.btn-cancel').prop('disabled', true);
		badge.show(root.find('.buttons .badge'), 'icon-spinner', 'spinner-text');

		return $.when($(document).delay(500)).done(createSaveFiltersApiRequest);
	};

	var createSaveFiltersApiRequest = function () {
		return medicalDeviceGroupHelper.createSaveFiltersApiRequest(getMedicalDeviceGroupId()).done(function () {
			if ($('.medical-device-table').length === 0) {
				location.reload();
				return;
			}

			root.find('.btn-cancel').prop('disabled', false);

			// Remove the old (not cloned) search form and thus preserve the changes of the
			// medical device group filters.
			var containers = root.find('.medical-device-group-search-form .search-form-container');

			if (containers.length > 1) {
				containers.last().remove();
			}

			hideSearchFormContainer();
			cloneSearchFormContainer();
			loadMedicalDevices(getMedicalDeviceGroupUrl() + '/medical-devices');

			badge.show(root.find('.buttons .badge'), 'icon-saved', 'saved-text', 5000);
		});
	};

	return {
		init: init,
	};
})(jQuery);

export { medicalDeviceGroupHelper, medicalDeviceGroupList, medicalDeviceGroupDetail };
